import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import HealthAndSafetyOutlinedIcon from "@mui/icons-material/HealthAndSafetyOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import { Stack, SxProps } from "@mui/material";
import { SettingsPageText } from "../../data/texts";
import { StyledSettingsTab } from "../../styled-cmps/settings-tab";

interface SettingsHeaderTabsProps {
  onTabClick: (cta: SettingsPageText) => void;
  selectedTab: string;
  sx?: SxProps;
}

const SettingsHeaderTabs = ({
  onTabClick,
  selectedTab,
  sx,
}: SettingsHeaderTabsProps) => {
  const isSelected = (id: SettingsPageText) => selectedTab === id;
  return (
    <Stack
      sx={{ ...sx, overflowX: "auto", paddingBottom: "4px" }}
      flexDirection={"row"}
      gap={"15px"}
    >
      <StyledSettingsTab
        onClick={() => onTabClick(SettingsPageText.PROFILE)}
        startIcon={<PermIdentityOutlinedIcon />}
        isSelected={isSelected(SettingsPageText.PROFILE)}
      >
        {SettingsPageText.PROFILE}
      </StyledSettingsTab>

      <StyledSettingsTab
        onClick={() => onTabClick(SettingsPageText.BILLING)}
        startIcon={<CreditCardOutlinedIcon />}
        isSelected={isSelected(SettingsPageText.BILLING)}
      >
        {SettingsPageText.BILLING.toUpperCase()}
      </StyledSettingsTab>

      <StyledSettingsTab
        onClick={() => onTabClick(SettingsPageText.NOTIFICATIONS)}
        startIcon={<NotificationsOutlinedIcon />}
        isSelected={isSelected(SettingsPageText.NOTIFICATIONS)}
      >
        {SettingsPageText.NOTIFICATIONS.toUpperCase()}
      </StyledSettingsTab>

      <StyledSettingsTab
        onClick={() => onTabClick(SettingsPageText.SECURITY)}
        startIcon={<HealthAndSafetyOutlinedIcon />}
        isSelected={isSelected(SettingsPageText.SECURITY)}
      >
        {SettingsPageText.SECURITY.toUpperCase()}
      </StyledSettingsTab>
    </Stack>
  );
};

export default SettingsHeaderTabs;
